import isOneWebDomainRuntime from "./avaAppRuntime";
import { AVA_APP_NAME } from "./constants";

/**
 * Builds an absolute internal URL for navigation helpers such as `window.open`.
 *
 * In One Web Domain (AvaApp) the router is mounted under the `/exemptions`
 * basename, so links built only from `window.location.origin` resolve to a
 * non-existent route and render the shell error page. This prepends the app
 * basename when running inside AvaApp and leaves standalone behaviour unchanged.
 *
 * @param path - Internal route path, with or without a leading slash.
 * @returns Absolute URL pointing at the route within the current deployment.
 */
export const getInternalUrl = (path: string): string => {
    const prefix = isOneWebDomainRuntime() ? `/${AVA_APP_NAME}` : "";
    return `${window.location.origin}${prefix}/${path.replace(/^\//, "")}`;
};

export default getInternalUrl;
